module.exports = __webpack_public_path__ + "img/cl1.19522b88.jpg";